var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditBtnForCarousel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9869_8405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 51C10 27.2518 29.2518 8 53 8C76.7482 8 96 27.2518 96 51C96 74.7482 76.7482 94 53 94C29.2518 94 10 74.7482 10 51Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3348 31.9205C74.7951 33.38 74.7951 35.7471 73.3348 37.2066L71.4464 39.0951L64.9062 32.5547L66.7947 30.6663C68.255 29.2063 70.622 29.2063 72.0819 30.6663L73.3348 31.9205Z",
    fill: "#00ACEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0459 40.0569L53.1004 58.1426H53.099L45.8555 51.2283L64.8024 33.1426L72.0459 40.0569Z",
    fill: "#00EFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1606 51L53.0004 57.8395L52.9367 57.9032L43.4766 60.5238L46.0969 51.0637L46.1606 51Z",
    fill: "#FEDB41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2836 56.8491C71.6563 56.8491 71.148 57.3574 71.148 57.9847V68.0676C71.1457 69.9484 69.622 71.4722 67.7411 71.4744H35.8772C33.9964 71.4722 32.4726 69.9484 32.4704 68.0676V38.4749C32.4726 36.5945 33.9964 35.0703 35.8772 35.0681H45.9602C46.5874 35.0681 47.0958 34.5597 47.0958 33.9325C47.0958 33.3052 46.5874 32.7969 45.9602 32.7969H35.8772C32.7428 32.8004 30.2028 35.3405 30.1992 38.4749V68.0676C30.2028 71.202 32.7428 73.7421 35.8772 73.7456H67.7411C70.8756 73.7421 73.4156 71.202 73.4192 68.0676V57.9847C73.4192 57.3574 72.9108 56.8491 72.2836 56.8491Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9689 29.8753C70.9714 27.8827 67.7384 27.8827 65.7414 29.8753L45.481 50.1357C45.3426 50.2745 45.2419 50.4466 45.1896 50.6352L42.5258 60.2527C42.4162 60.6471 42.5276 61.0694 42.8168 61.3591C43.1065 61.6483 43.5288 61.7596 43.9231 61.6505L53.5407 58.9863C53.7297 58.9339 53.9023 58.8332 54.0411 58.6944L54.1054 58.6296L74.3006 38.4345C76.2963 36.4392 76.2963 33.2041 74.3006 31.2088L72.9689 29.8753ZM46.8868 53.0177L51.1582 57.2895L45.2495 58.9264L46.8868 53.0177ZM53.303 57.8276V57.8267L54.0433 58.5671L53.303 57.8276ZM53.303 56.2218L47.955 50.8738L64.5366 34.2922L69.8841 39.6393L53.303 56.2218ZM72.6947 36.8287L71.4899 38.0335L66.1428 32.686L67.3476 31.4811C68.4566 30.3744 70.2527 30.3744 71.3622 31.4811L72.6947 32.815C73.8037 33.9231 73.8037 35.7206 72.6947 36.8287Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9869_8405",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.647059 0 0 0 0 0.941176 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9869_8405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9869_8405",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtnForCarousel);
export default __webpack_public_path__ + "static/media/edit-btn-for-carousel.392658a3250a9b237cc20d8728a4aa7b.svg";
export { ForwardRef as ReactComponent };